import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="main"
export default class extends Controller {
  connect() {
    this.#setListeners()
  }

  #setListeners() {
    this.#turbo_frame_missing()
    this.#turbo_submit_start()
    this.#turbo_submit_end()
  }  

  #turbo_submit_start() {
    document.removeEventListener("turbo:submit-start", this.#submitStart)
    document.addEventListener("turbo:submit-start", this.#submitStart);
  }

  #turbo_submit_end() {
    document.removeEventListener("turbo:submit-end", this.#submitEnd);
    document.addEventListener("turbo:submit-end", this.#submitEnd);
  }

  #turbo_frame_missing() {
    document.removeEventListener("turbo:frame-missing", this.#frameMissing);
    document.addEventListener("turbo:frame-missing", this.#frameMissing);
  }

  #frameMissing(event) {
    if (event.detail.response.redirected) {
      event.preventDefault();
      event.detail.visit(event.detail.response, { action: "replace" });
    }
  }

  #submitStart({ target }) {
    Turbo.config.drive.progressBarDelay = 1000
    // Turbo.setProgressBarDelay(1000);
    Turbo.navigator.delegate.adapter.showProgressBar();
  }
  
  #submitEnd({ target }) {
    Turbo.navigator.delegate.adapter.progressBar.hide()
    console.log(target)
    // if (loader) {      
    //   loader.close()
    // }
  }

  onSubmit(event) {
    let form = document.getElementById(event.currentTarget.dataset.formId)
    form.submit()
    const ele = document.querySelector('div[data-controller="modal"]')
    if (ele) {
      ele.remove()
      document.querySelector("body").classList.remove("no-scroll")
    }
  }
}
